import { EditContainer } from 'features/globalSetup/forms/Prebid/Modules/VendorSpecificForm/GeneralForm'

export const GeneralPage = (): React.JSX.Element => {
  return <EditContainer />
}
